import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HorizontalNavbar from './components/HorizontalNavbar';
import VerticalNavbar from './components/VerticalNavbar';
import AboutMeSection from './components/AboutMeSection';
import Projects from './components/Projects';
import Skills from './components/Skills';
import CAssemblyProjects from './components/CAssemblyProjects';
import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    <Router>
      <Analytics />
      <div className="Layout">
        <VerticalNavbar />
        <div className="Main">
          <HorizontalNavbar />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <AboutMeSection />
                  <Projects />
                  <Skills />
                </>
              }
            />
            <Route path="/projects/c-assembly" element={<CAssemblyProjects />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;